import React, { useEffect } from "react";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";

import ProductsTableComponent from "../../../components/admin/products-manager/ProductsTable";
import { ProductsAddDrawer } from "../../../components/admin/products-manager/ProductsAddDrawer";

import { useGetProductsListQuery } from "../../../store/masters/mastersApis";
import { baseUrl, defaultPaginate } from "../../../helpers/constants";
import { AddOutlined } from "@mui/icons-material";
import { SearchRecords } from "../../../components/Common/SearchRecords";

const ProductsContainer = (props) => {
    const { showDrawer, formType, initialValues, pagination } = props;
    const { isLoading, data: products, isFetching } = useGetProductsListQuery(pagination);

    const handleAddProduct = () => {
        props.changeProductsInitialState({
            showDrawer: true,
            formType: "Add",
            initialValues: null,
        });
    };

    useEffect(() => {
        props.handlePaginationState(defaultPaginate);
    }, []);

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    };

    const handleDrawerClose = () => {
        props.changeProductsInitialState({ showDrawer: false, formType: "", initialValues: null });
    };

    const handleProductEdit = (data, type) => {
        let payload = {
            id: data.id,
            name: data.name,
            price: data.price,
            description: data.description,
            image_url: baseUrl + data.image_url,
            is_active: data.is_active,
        };
        props.changeProductsInitialState({ showDrawer: true, formType: type, initialValues: payload });
    };

    return (
        <Stack spacing={2}>
            <Grid container justifyContent="space-between">
                <Grid item xs={6} sx={{ alignSelf: "center" }}>
                    <Typography variant="h6">
                        Products{" "}
                        <span style={{ color: "gray", fontSize: "10px", verticalAlign: "super" }}>
                            ({products?.count || 0})
                        </span>{" "}
                    </Typography>
                </Grid>
                <Grid
                    item
                    xs={6}
                    sx={{ alignSelf: "center" }}
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                >
                    <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                    <Button
                        disableElevation
                        variant="contained"
                        sx={{
                            borderRadius: "8px",
                            marginLeft: 2,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            fontSize: "16px",
                        }}
                        onClick={() => handleAddProduct()}
                    >
                        <AddOutlined />
                        New Product
                    </Button>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12}>
                    <ProductsTableComponent
                        edit={(val, type) => handleProductEdit(val, type)}
                        loading={isLoading}
                        fetching={isFetching}
                        count={products?.count}
                        data={products?.results || []}
                        pagination={pagination}
                        handlePagination={(val) => handlePagination(val)}
                    />
                </Grid>
            </Grid>
            <ProductsAddDrawer
                show={showDrawer}
                close={handleDrawerClose}
                formType={formType}
                initialValues={initialValues}
            />
        </Stack>
    );
};

export default ProductsContainer;
